import Scrolling from '../utils/class/scrolling';

export default class ModalContentSection {
    constructor(query) {
        this.el = document.querySelector(query);
        if (!this.el) return;

        this.openButtons = this.el.querySelectorAll('[data-modal-open]');
        this.closeButtons = this.el.querySelectorAll('[data-modal-close]');
        this.modalsWrap = this.el.querySelector('.modal-content-section__modals');
        this.modals = this.el.querySelectorAll('.modal-content-section__modal');

        if (!this.openButtons.length || !this.modalsWrap || !this.modals.length) return;

        this.scrolling = new Scrolling();

        this.init();
    }

    init() {
        this.openButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                this.openModal(button.getAttribute('data-modal-open'));
            });
        });

        this.initCustomScrollbars();

        this.closeButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                this.closeAll();
            });
        });

        this.modals.forEach((modal) => {
            modal.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        });

        this.modalsWrap.addEventListener('click', () => {
            this.closeAll();
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.closeAll();
            }
        });
    }

    openModal(id) {
        const modal = document.getElementById(id);
        if (!modal) return;

        this.modals.forEach((item) => {
            item.classList.remove('active');
        });

        this.scrolling.disable();

        this.modalsWrap.classList.add('active');
        modal.classList.add('active');

        requestAnimationFrame(() => {
            window.dispatchEvent(new Event('resize'));
        });
    }

    initCustomScrollbars() {
        this.initCustomScrollbar(
            '.modal-content-section__table',
            'modal-content-section__table-scroll-content'
        );

        // this.initCustomScrollbar(
        //     '.modal-content-section__modal',
        //     'modal-content-section__modal-scroll-content'
        // );
    }

    initCustomScrollbar(selector, contentClass) {
        this.el.querySelectorAll(selector).forEach((element) => {
            if (element.classList.contains('custom-scroll-ready')) return;

            const content = document.createElement('div');
            content.className = contentClass;

            while (element.firstChild) {
                content.appendChild(element.firstChild);
            }

            const scrollbar = document.createElement('div');
            scrollbar.className = 'modal-content-section__custom-scrollbar';

            const thumb = document.createElement('div');
            thumb.className = 'modal-content-section__custom-scrollbar-thumb';

            scrollbar.appendChild(thumb);
            element.appendChild(content);
            element.appendChild(scrollbar);

            const update = () => {
                const { scrollHeight } = content;
                const { clientHeight } = content;
                const trackHeight = scrollbar.clientHeight;

                if (scrollHeight <= clientHeight) {
                    scrollbar.style.display = 'none';
                    return;
                }

                scrollbar.style.display = 'block';

                const thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, 40);
                const maxThumbTop = trackHeight - thumbHeight;
                const maxScrollTop = scrollHeight - clientHeight;
                const thumbTop = (content.scrollTop / maxScrollTop) * maxThumbTop;

                thumb.style.height = `${thumbHeight}px`;
                thumb.style.transform = `translateY(${thumbTop}px)`;
            };

            content.addEventListener('scroll', update);
            window.addEventListener('resize', update);

            update();

            element.classList.add('custom-scroll-ready');
        });
    }

    closeAll(enableScroll = true) {
        this.modals.forEach((modal) => {
            modal.classList.remove('active');
        });

        this.modalsWrap.classList.remove('active');

        if (enableScroll) {
            this.scrolling.enable();
        }
    }
}